
const Input = ({placeholder, style, disabled, handleChange, value }) => {

  return (
    <input placeholder={placeholder}  style={style} disabled={disabled || false} onChange={(e)=>handleChange(e.target.value)} value={value || ""}/>
  )
} 
export default Input;